import Container from "@components/common/Container";
import MinimalFooter from "@components/common/MinimalFooter";
import { Check } from "@icon-park/svg";
import { Icon, Title } from "@justhome/react-ui";
import { useApplicationTranslation } from "@lib/hooks/translations";
import Image from "next/image";
import { FC } from "react";
import { DefaultValues } from "react-hook-form";
import DynamicForm, { FieldValues } from "../DynamicForm";
import { FormStepComponent } from "../FormSteps/FormSteps";
import ApplicationHeader from "../SplitLayout/ApplicationHeader";

interface ListItemProps {
  name: string;
  value: string;
}

const ListItem: FC<ListItemProps> = ({ name, value }) => {
  return (
    <li className="flex gap-2xs text-body-1">
      <span className="flex items-center text-primary-800 h-m">
        <Icon icon={Check} size="18" />
      </span>
      <span>
        {name}
        <span className="font-medium">{value}</span>
      </span>
    </li>
  );
};

const ZeroStep = <T extends FieldValues>({
  onNext,
  step,
  value,
}: FormStepComponent<T>) => {
  const { t } = useApplicationTranslation();
  return (
    <div className="flex flex-col min-h-screen">
      <ApplicationHeader border />
      <Container
        padding
        className="grow grid grid-cols-12 place-content-center"
      >
        <div className="col-span-12 m:col-span-8 m:col-start-3 my-m">
          <Title className="text-d3 mb-3s m:mb-3m">{step.config.title}</Title>
          <DynamicForm
            defaultValues={value as DefaultValues<T>}
            formDefinition={step.config}
            onSubmit={(values) => onNext(values)}
          ></DynamicForm>
          <div className="mt-m m:mt-3xl bg-primary-25 border border-primary-800 py-s px-2s m:p-m flex gap rounded-m items-center">
            <div className="flex-1">
              <Title className="text-h2 mb-3s m:mb-m">
                {t("zero_step_card_title")}
              </Title>
              <ul className="space-y-3xs m:space-y-2s">
                <ListItem
                  name={t("zero_step_card_li_1")}
                  value={t("zero_step_card_li_1_bold")}
                />
                <ListItem
                  name={t("zero_step_card_li_2")}
                  value={t("zero_step_card_li_2_bold")}
                />
                <ListItem
                  name={t("zero_step_card_li_3")}
                  value={t("zero_step_card_li_3_bold")}
                />
              </ul>
            </div>
            <div className="flex-none hidden m:block">
              <Image
                src="/assets/img/checklist.png"
                width="200"
                height="200"
                alt=""
              />
            </div>
          </div>
        </div>
      </Container>
      <MinimalFooter isFullWidth />
    </div>
  );
};

export default ZeroStep;
